module.exports = __webpack_public_path__ + "img/circle-desktop.3130c931.svg";